import { Component, OnInit,HostListener,ViewChild,ElementRef } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
interface Step {
  label: string;
  subtitle: string;
  icon: string;
}

@Component({
  selector: 'app-partner-preferences',
  templateUrl: './partner-preferences.component.html',
  styleUrls: ['./partner-preferences.component.scss']
})
export class PartnerPreferencesComponent implements OnInit {
  @ViewChild('stepperScroll') stepperScroll!: ElementRef;
@HostListener('document:click', ['$event'])

closeDropdowns(event: MouseEvent) {

  const target = event.target as HTMLElement;

  if(!target.closest('.custom-dropdown')){
    
    this.showReligionDropdown = false;
    this.showCasteDropdown = false;
    this.showSubcasteDropdown = false;
    this.filteredCasteList = this.castes;
this.filteredSubcasteList = this.subcastes;

    this.showLanguageDropdown = false;
    this.showEducationDropdown = false;
    this.showHigherEducationDropdown = false;

    this.showOccupationDropdown = false;
    this.showEmploymentDropdown = false;

    this.showCountryDropdown = false;
    this.showStateDropdown = false;
    this.showDistrictDropdown = false;
    this.showCityDropdown = false;

    this.zodiacOpen = false;
    this.natchatraOpen = false;
    this.gothraOpen = false;
    this.manglikOpen = false;

    this.maritalOpen = false;
    this.physicalOpen = false;
    this.familyOpen = false;

    this.dietOpen = false;
    this.smokingOpen = false;
    this.drinkingOpen = false;
  }
}
  // Dropdown lists
  rasis: any[] = [];
  natchatras: any[] = [];
  gothrams: any[] = [];
  citys: any[] = [];
  districts: any[] = [];
  states: any[] = [];
  countrys: any[] = [];
  educations: any[] = [];
  highereducations: any[] = [];
  occupations: any[] = [];
  employmentypes: any[] = [];
  religions: any[] = [];
  castes: any[] = [];
  subcastes: any[] = [];
  languages: any[] = [];
  citizens: any[] = [];
  filteredCasteList: any[] = [];
filteredSubcasteList: any[] = [];


  // Religion Dropdown
showReligionDropdown = false;
religionSearch = '';
// Caste
showCasteDropdown = false;
casteSearch = '';

// Subcaste
showSubcasteDropdown = false;
subcasteSearch = '';

// Mother Tongue
showLanguageDropdown = false;
languageSearch = '';
// Education
showEducationDropdown = false;
educationSearch = '';

// Higher Education
showHigherEducationDropdown = false;
higherEducationSearch = '';
// Occupation
showOccupationDropdown = false;
occupationSearch = '';

// Employment Type
showEmploymentDropdown = false;
employmentSearch = '';
zodiacOpen=false;
natchatraOpen=false;
gothraOpen=false;
manglikOpen=false;


zodiacSearch='';
natchatraSearch='';
gothraSearch='';
showCountryDropdown=false;
showStateDropdown=false;
showDistrictDropdown=false;
showCityDropdown=false;

countrySearch='';
stateSearch='';
districtSearch='';
citySearch='';

maritalOpen=false;
physicalOpen=false;
familyOpen=false;

maritalSearch = '';
physicalSearch = '';
familySearch = '';
  profileDetails: any;
  loading = true;
  isSaving = false;

  activeStep: number = 0;
  isNonReligiousUser: boolean = false;
  
  steps: Step[] = [
    { label: 'Criteria', subtitle: 'Basic Specs', icon: 'person' },
    { label: 'Faith', subtitle: 'Religion & Sect', icon: 'church' },
    { label: 'Education', subtitle: 'Studies', icon: 'school' },
    { label: 'Career', subtitle: 'Work & Income', icon: 'business_center' },
    { label: 'Place', subtitle: 'Location preferences', icon: 'distance' },
    { label: 'Lifestyle', subtitle: 'Habits & Diet', icon: 'restaurant' },
    { label: 'Stars / Horoscope', subtitle: 'Kundli & Gothra', icon: 'star' }
  ];
  dietOpen = false;
smokingOpen = false;
drinkingOpen = false;


dietSearch = '';
smokingSearch = '';
drinkingSearch = '';


dietList = [
  'Vegetarian',
  'Eggetarian',
  'Non-Vegetarian',
  'No Preference'
];
maritalList = [
  'Never Married',
  'Divorced',
  'Widowed',
  'No Preference'
];


physicalList = [
  'Normal',
  'Physically Challenged',
  'No Preference'
];


familyList = [
  'Nuclear',
  'Joint',
  'No Preference'
];


smokingList = [
  'No',
  'Occasional',
  'Yes',
  'No Preference'
];


drinkingList = [
  'No',
  'Socially',
  'Yes',
  'No Preference'
];

  formData: any = {
    minAge: null,
    maxAge: null,
    minHeight: null,
    maxHeight: null,
    minWeight: null,
    maxWeight: null,
    maritalStatus: '',
    physicalStatus: '',
    familyType: '',
    religion: '',
    caste: '',
    subcaste: '',
    motherTongue: '',
    education: '',
    higherEducation: '',
    occupation: '',
    employmentType: '',
    minSalary: null,
    maxSalary: null,
    citizenship: '',
    country: '',
    state: '',
    district: '',
    preferredCity: '',
    locationProximity: '',
    dietPreference: '',
    smoking: '',
    drinking: '',
    zodiac: '',
    natchatra: '',
    manglik: '',
    gothra: ''
  };

  constructor(
    private apiService: ApiServiceService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.loading = true;

    forkJoin([
      this.apiService.getRasi(),
      this.apiService.getNatchra(),
      this.apiService.getGothrams(),
      this.apiService.getCity(),
      this.apiService.getDistrict(),
      this.apiService.getState(),
      this.apiService.getCountry(),
      this.apiService.getEducation(),
      this.apiService.getHigherEducation(),
      this.apiService.getOccupation(),
      this.apiService.getEmploymentType(),
      this.apiService.getReligions(),
      this.apiService.getCastes(),
      this.apiService.getSubCastes(),
      this.apiService.getLanguages(),
      this.apiService.getCitizens()
    ]).subscribe(
      ([
        rasisRes, natchatrasRes, gothramsRes, citysRes, districtsRes,
        statesRes, countrysRes, educationsRes, highereducationsRes,
        occupationsRes, employmentypesRes, religionsRes, castesRes,
        subcastesRes, languagesRes, citizensRes
      ]) => {
        this.rasis = rasisRes.data || [];
        this.natchatras = natchatrasRes.data || [];
        this.gothrams = gothramsRes.data || [];
        this.citys = citysRes.data || [];
        this.districts = districtsRes.data || [];
        this.states = statesRes.data || [];
        this.countrys = countrysRes.data || [];
        this.educations = educationsRes.data || [];
        this.highereducations = highereducationsRes.data || [];
        this.occupations = occupationsRes.data || [];
        this.employmentypes = employmentypesRes.data || [];
        this.religions = religionsRes.data || [];
        this.castes = castesRes.data || [];
        this.subcastes = subcastesRes.data || [];
        this.languages = languagesRes.data || [];
        this.citizens = citizensRes.data || [];
        

console.log("CITIZENSHIP DATA", this.citizens);
console.log("CITIZENSHIP SAMPLE", this.citizens[0]);
console.log("COUNTRY DATA", this.countrys);
console.log("STATE DATA", this.states);
console.log("DISTRICT DATA", this.districts);
console.log("CITY DATA", this.citys);
console.log("COUNTRY SAMPLE", this.countrys[0]);
console.log("STATE SAMPLE", this.states[0]);
console.log("DISTRICT SAMPLE", this.districts[0]);
console.log("CITY SAMPLE", this.citys[0]);
console.log("CITY LENGTH", this.citys.length);
console.log("ALL CITY SAMPLE", this.citys.slice(0,5));


this.getEditDetail();

      },
      (error) => {
        console.error('Error fetching dropdown selections:', error);
        this.loading = false;
      }
    );
  }
  goBack(): void {
  this.location.back();
}

  getEditDetail() {
    this.loading = true;
    const sessionToken = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');
    if (sessionToken && profileId) {
      this.apiService.getEditDetails(sessionToken, profileId).subscribe(
        (res: any) => {
          if (res.status === 'success' && res.data) {
            const relId = res.data.religion_info?.religion_id;
            const relIdStr = typeof relId === 'object' ? relId?._id : relId;
            const relName = res.data.religion_info?.religion_nme || '';
            this.isNonReligiousUser = String(relIdStr) === '66040275ccff8db6ddf8eecb' || relName.toLowerCase().includes('non-relig') || relName.toLowerCase().includes('atheist') || relName.toLowerCase().includes('secular');
            if (this.isNonReligiousUser) {
              this.steps = [
                { label: 'Criteria', subtitle: 'Basic Specs', icon: 'person' },
                { label: 'Faith', subtitle: 'Secular / Any Faith', icon: 'public' },
                { label: 'Education', subtitle: 'Studies', icon: 'school' },
                { label: 'Career', subtitle: 'Work & Income', icon: 'business_center' },
                { label: 'Place', subtitle: 'Location preferences', icon: 'distance' },
                { label: 'Lifestyle', subtitle: 'Habits & Diet', icon: 'restaurant' }
              ];
            }
          }
        }
      );

      this.apiService.getPartnerDetails(sessionToken, profileId).subscribe(
        (response) => {
          this.profileDetails = response.data;
          this.patchFormValues();
          this.loading = false;
        },
        (error) => {
          console.error('Error fetching partner preferences:', error);
          this.loading = false;
        }
      );
    } else {
      this.loading = false;
    }
  }

  private patchFormValues() {
    if (!this.profileDetails) return;

    if (this.profileDetails.personal_preference) {
      const p = this.profileDetails.personal_preference;
      this.formData.minAge = p.age_from || null;
      this.formData.maxAge = p.age_to || null;
      this.formData.minHeight = p.height_from || null;
      this.formData.maxHeight = p.height_to || null;
      this.formData.minWeight = p.weight_from || null;
      this.formData.maxWeight = p.weight_to || null;
      this.formData.minSalary = p.salary_from || null;
      this.formData.maxSalary = p.salary_to || null;
      this.formData.maritalStatus = p.marital_status || '';
      this.formData.physicalStatus = p.physical_status || '';
      this.formData.familyType = p.family_type || '';
      this.formData.citizenship = p.citizenship_id?._id || p.citizenship_id || '';
      this.formData.motherTongue = p.language_id?._id || p.language_id || '';
    }

    if (this.profileDetails.religious_preference) {
      const r = this.profileDetails.religious_preference;
      this.formData.religion = r.religion_id?._id || r.religion_id || '';
      this.formData.caste = r.caste_id?._id || r.caste_id || '';
      this.formData.subcaste = r.sub_caste_id?._id || r.sub_caste_id || '';
    }

    if (this.profileDetails.education_preference) {
      const e = this.profileDetails.education_preference;
      if (e.education_id && e.education_id.length > 0) {
        this.formData.education = e.education_id[0]?._id || e.education_id[0] || '';
      }
      if (e.higher_education_id && e.higher_education_id.length > 0) {
        this.formData.higherEducation = e.higher_education_id[0]?._id || e.higher_education_id[0] || '';
      }
    }

    if (this.profileDetails.profession_preference) {
      const pr = this.profileDetails.profession_preference;
      if (pr.occupation_id && pr.occupation_id.length > 0) {
        this.formData.occupation = pr.occupation_id[0]?._id || pr.occupation_id[0] || '';
      }
      if (pr.employmentype_id && pr.employmentype_id.length > 0) {
        this.formData.employmentType = pr.employmentype_id[0]?._id || pr.employmentype_id[0] || '';
      }
    }

    if (this.profileDetails.location_preference) {
      const l = this.profileDetails.location_preference;
      this.formData.country = l.country_id?._id || l.country_id || '';
      this.formData.state = l.state_id?._id || l.state_id || '';
      this.formData.district = l.dist_id?._id || l.dist_id || '';
      this.formData.preferredCity = l.city_id?._id || l.city_id || '';
      this.formData.locationProximity = l.location_proximity || '';
    }

    if (this.profileDetails.lifestyle_and_food_preference) {
      const ls = this.profileDetails.lifestyle_and_food_preference;
      this.formData.dietPreference = ls.food || '';
      this.formData.smoking = ls.smoking || '';
      this.formData.drinking = ls.drinking || '';
    }

    if (this.profileDetails.horoscope_preference) {
      const h = this.profileDetails.horoscope_preference;
      this.formData.zodiac = h.rasi_id?._id || h.rasi_id || '';
      this.formData.natchatra = h.natchr_id?._id || h.natchr_id || '';
      this.formData.manglik = h.dosham || '';
      this.formData.gothra = h.gothrm_id?._id || h.gothrm_id || '';
    }
  }
  filteredReligions() {
  return this.religions.filter(rel =>
    rel.religion_nme
      ?.toLowerCase()
      .includes(this.religionSearch.toLowerCase())
  );
}
previousStep(): void {
  if (this.activeStep > 0) {
    this.activeStep--;
    this.scrollToActiveStep();
  }
}

nextStep(): void {
  if (this.activeStep < this.steps.length - 1) {
    this.activeStep++;
    this.scrollToActiveStep();
  }
}
scrollToActiveStep() {
  setTimeout(() => {
    const container = this.stepperScroll?.nativeElement;

    if (!container) {
      return;
    }

    const activeButton = container.querySelector(
      `.mobile-step:nth-child(${this.activeStep + 1})`
    ) as HTMLElement;

    if (activeButton) {
      activeButton.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }, 50);
}
selectReligion(rel: any) {

  this.formData.religion = rel._id;

  // filter caste based on religion
  this.filteredCasteList = this.castes.filter(
    caste => caste.religion_id === rel._id
  );


  // reset lower selections
  this.formData.caste = '';
  this.formData.subcaste = '';

  this.filteredSubcasteList = [];

  this.showReligionDropdown = false;
  this.religionSearch = '';

  console.log("Selected Religion:", rel.religion_nme);
  console.log("Filtered Castes:", this.filteredCasteList);
}

get selectedReligionName(): string {
  const religion = this.religions.find(
    r => r._id === this.formData.religion
  );

  return religion?.religion_nme || 'No Preference';
}
filteredCastes() {

  return this.castes.filter(caste =>

    caste.religion_id === this.formData.religion &&

    caste.caste_nme
      ?.toLowerCase()
      .includes(this.casteSearch.toLowerCase())

  );

}

selectCaste(caste: any) {

  this.formData.caste = caste._id;


  // filter subcaste based on caste
  this.filteredSubcasteList = this.subcastes.filter(
    sub => sub.caste_id === caste._id
  );


  this.formData.subcaste = '';

  this.showCasteDropdown = false;
  this.casteSearch = '';

  console.log("Selected Caste:", caste.caste_nme);
  console.log("Filtered Subcastes:", this.filteredSubcasteList);

}

get selectedCasteName(): string {
  const caste = this.castes.find(
    c => c._id === this.formData.caste
  );

  return caste?.caste_nme || 'No Preference';
}
filteredSubcastes() {

  return this.subcastes.filter(sub =>

    sub.caste_id === this.formData.caste &&

    sub.subcaste_nme
      ?.toLowerCase()
      .includes(this.subcasteSearch.toLowerCase())

  );

}

selectSubcaste(sub: any) {
  this.formData.subcaste = sub._id;
  this.showSubcasteDropdown = false;
  this.subcasteSearch = '';
}

get selectedSubcasteName(): string {
  const sub = this.subcastes.find(
    s => s._id === this.formData.subcaste
  );

  return sub?.subcaste_nme || 'No Preference';
}
filteredLanguages() {
  return this.languages.filter(lang =>
    lang.language_nme
      ?.toLowerCase()
      .includes(this.languageSearch.toLowerCase())
  );
}

selectLanguage(lang: any) {
  this.formData.motherTongue = lang._id;
  this.showLanguageDropdown = false;
  this.languageSearch = '';
}

get selectedLanguageName(): string {
  const lang = this.languages.find(
    l => l._id === this.formData.motherTongue
  );

  return lang?.language_nme || 'No Preference';
}
filteredEducations() {
  return this.educations.filter(edu =>
    edu.education_nme
      ?.toLowerCase()
      .includes(this.educationSearch.toLowerCase())
  );
}

selectEducation(edu: any) {
  this.formData.education = edu._id;
  this.showEducationDropdown = false;
  this.educationSearch = '';
}

get selectedEducationName(): string {
  const edu = this.educations.find(
    e => e._id === this.formData.education
  );

  return edu?.education_nme || 'No Preference';
}
filteredHigherEducations() {
  return this.highereducations.filter(edu =>
    edu.highereducation_nme
      ?.toLowerCase()
      .includes(this.higherEducationSearch.toLowerCase())
  );
}

selectHigherEducation(edu: any) {
  this.formData.higherEducation = edu._id;
  this.showHigherEducationDropdown = false;
  this.higherEducationSearch = '';
}

get selectedHigherEducationName(): string {
  const edu = this.highereducations.find(
    e => e._id === this.formData.higherEducation
  );

  return edu?.highereducation_nme || 'No Preference';
}
filteredCountries(){
  return this.countrys.filter(x =>
    x.name_0?.toLowerCase()
    .includes(this.countrySearch.toLowerCase())
  );
}


filteredStates(){

  if(!this.formData.country){
    return [];
  }

  const selectedCountry = this.countrys.find(
    x => x._id === this.formData.country
  );


  return this.states.filter(x =>
    x.country_id === selectedCountry?.country_id &&
    x.name_1?.toLowerCase()
    .includes(this.stateSearch.toLowerCase())
  );

}



filteredDistricts(){

  if(!this.formData.state){
    return [];
  }

  const selectedState = this.states.find(
    x => x._id === this.formData.state
  );


  return this.districts.filter(x =>
    x.state_id === selectedState?.state_id &&
    x.name_2?.toLowerCase()
    .includes(this.districtSearch.toLowerCase())
  );

}
filteredCities(){

  if(!this.formData.district){
    return [];
  }

  const selectedDistrict = this.districts.find(
    x => x._id === this.formData.district
  );

  return this.citys.filter(x =>
    x.id_2 === selectedDistrict?.id_2 &&
    x.city_nme
      ?.toLowerCase()
      .includes(this.citySearch.toLowerCase())
  );

}
selectCountry(item:any){

 this.formData.country=item._id;

 this.formData.state='';
 this.formData.district='';
 this.formData.preferredCity='';
 console.log("SELECTED COUNTRY", item);
 console.log(
   "AVAILABLE STATES",
   this.filteredStates()
 );

 this.showCountryDropdown=false;

}


selectState(item:any){

 this.formData.state=item._id;

 this.formData.district='';
 this.formData.preferredCity='';

 this.showStateDropdown=false;

}


selectDistrict(item:any){

 this.formData.district=item._id;

 this.formData.preferredCity='';

 this.showDistrictDropdown=false;

}
selectCity(item:any){

  this.formData.preferredCity = item._id;

  this.showCityDropdown = false;

  this.citySearch = '';

}
get selectedCountryName(){

 const data=this.countrys.find(
  x=>x._id===this.formData.country
 );

 return data?.name_0 || 'No Preference';

}


get selectedStateName(){

 const data=this.states.find(
  x=>x._id===this.formData.state
 );

 return data?.name_1 || 'No Preference';

}


get selectedDistrictName(){

 const data=this.districts.find(
  x=>x._id===this.formData.district
 );

 return data?.name_2 || 'No Preference';

}
get selectedCityName(): string {

  const city = this.citys.find(
    x => x._id === this.formData.preferredCity
  );

  return city?.city_nme || 'No Preference';

}
filteredOccupations() {
  return this.occupations.filter(occ =>
    occ.occupation_nme
      ?.toLowerCase()
      .includes(this.occupationSearch.toLowerCase())
  );
}

selectOccupation(occ: any) {
  this.formData.occupation = occ._id;
  this.showOccupationDropdown = false;
  this.occupationSearch = '';
}

get selectedOccupationName(): string {
  const occ = this.occupations.find(
    o => o._id === this.formData.occupation
  );

  return occ?.occupation_nme || 'No Preference';
}
filteredEmployments() {
  return this.employmentypes.filter(emp =>
    emp.employment_type_nme
      ?.toLowerCase()
      .includes(this.employmentSearch.toLowerCase())
  );
}

selectEmployment(emp: any) {
  this.formData.employmentType = emp._id;
  this.showEmploymentDropdown = false;
  this.employmentSearch = '';
}

get selectedEmploymentName(): string {
  const emp = this.employmentypes.find(
    e => e._id === this.formData.employmentType
  );

  return emp?.employment_type_nme || 'No Preference';
}
  get percentComplete(): number {
    if (!this.formData) return 0;
    const keys = Object.keys(this.formData);
    if (keys.length === 0) return 0;
    let filledCount = 0;
    for (const key of keys) {
      const val = this.formData[key];
      if (val !== null && val !== undefined && val !== '' && val !== 'null') {
        filledCount++;
      }
    }
    return Math.round((filledCount / keys.length) * 100);
  }

  handleNext() {
    if (this.activeStep < this.steps.length - 1) {
      this.activeStep++;
    } else {
      this.saveAllPreferences();
    }
  }

  handleBack() {
    if (this.activeStep > 0) {
      this.activeStep--;
    }
  }

  goToStep(index: number) {
    this.activeStep = index;
  }
  selectDiet(value:any){
  this.formData.dietPreference = value;
  this.dietOpen = false;
}


selectSmoking(value:any){
  this.formData.smoking = value;
  this.smokingOpen = false;
}


selectDrinking(value:any){
  this.formData.drinking = value;
  this.drinkingOpen = false;
}
selectZodiac(item:any){
  this.formData.zodiac=item._id;
  this.zodiacOpen=false;
}


selectNatchatra(item:any){
  this.formData.natchatra=item._id;
  this.natchatraOpen=false;
}


selectGothra(item:any){
  this.formData.gothra=item._id;
  this.gothraOpen=false;
}


selectManglik(value:any){
  this.formData.manglik=value;
  this.manglikOpen=false;
}
selectMarital(value:any){
  this.formData.maritalStatus=value;
  this.maritalOpen=false;
}


selectPhysical(value:any){
  this.formData.physicalStatus=value;
  this.physicalOpen=false;
}


selectFamily(value:any){
  this.formData.familyType=value;
  this.familyOpen=false;
}
filteredZodiacList(){

 return this.rasis.filter(x =>
  x.rasi_nme.toLowerCase()
  .includes(this.zodiacSearch.toLowerCase())
 );

}


filteredNatchatraList(){

 return this.natchatras.filter(x =>
  x.natchr_nme.toLowerCase()
  .includes(this.natchatraSearch.toLowerCase())
 );

}


filteredGothraList(){

 return this.gothrams.filter(x =>
  x.gothram_nme.toLowerCase()
  .includes(this.gothraSearch.toLowerCase())
 );

}
getZodiacName(){

 const item=this.rasis.find(
 x=>x._id===this.formData.zodiac
 );

 return item?.rasi_nme;

}


getNatchatraName(){

 const item=this.natchatras.find(
 x=>x._id===this.formData.natchatra
 );

 return item?.natchr_nme;

}


getGothraName(){

 const item=this.gothrams.find(
 x=>x._id===this.formData.gothra
 );

 return item?.gothram_nme;

}
filteredDietList(){
  return this.dietList.filter(item =>
    item.toLowerCase().includes(this.dietSearch.toLowerCase())
  );
}
filteredMaritalList(){
  return this.maritalList.filter(item =>
    item.toLowerCase()
    .includes(this.maritalSearch.toLowerCase())
  );
}


filteredPhysicalList(){
  return this.physicalList.filter(item =>
    item.toLowerCase()
    .includes(this.physicalSearch.toLowerCase())
  );
}


filteredFamilyList(){
  return this.familyList.filter(item =>
    item.toLowerCase()
    .includes(this.familySearch.toLowerCase())
  );
}

filteredSmokingList(){
  return this.smokingList.filter(item =>
    item.toLowerCase().includes(this.smokingSearch.toLowerCase())
  );
}


filteredDrinkingList(){
  return this.drinkingList.filter(item =>
    item.toLowerCase().includes(this.drinkingSearch.toLowerCase())
  );
}

  submitPreference(action: string, formData: any) {
    const profileId = localStorage.getItem('profileId');
    const sessionToken = localStorage.getItem('sessionToken');

    if (!profileId || !sessionToken) {
      return null;
    }

    const payload = {
      action,
      type: 'preference',
      profileId,
      data: formData
    };

    return this.apiService.getPartner(payload, sessionToken);
  }

  saveSectionProgress() {
    this.isSaving = true;

    const personalPayload = {
      personal_preference: {
        age_from: this.formData.minAge,
        age_to: this.formData.maxAge,
        height_from: this.formData.minHeight,
        height_to: this.formData.maxHeight,
        weight_from: this.formData.minWeight,
        weight_to: this.formData.maxWeight,
        salary_from: this.formData.minSalary,
        salary_to: this.formData.maxSalary,
        marital_status: this.formData.maritalStatus || null,
        physical_status: this.formData.physicalStatus || null,
        family_type: this.formData.familyType || null,
        citizenship_id: this.formData.citizenship || null,
        language_id: this.formData.motherTongue || null
      }
    };

    const religiousPayload = {
      religious_preference: {
        religion_id: this.formData.religion || null,
        caste_id: this.formData.caste || null,
        sub_caste_id: this.formData.subcaste || null
      }
    };

    const educationPayload = {
      education_preference: {
        education_id: this.formData.education ? [this.formData.education] : [],
        higher_education_id: this.formData.higherEducation ? [this.formData.higherEducation] : []
      }
    };

    const professionPayload = {
      profession_preference: {
        occupation_id: this.formData.occupation ? [this.formData.occupation] : [],
        employmentype_id: this.formData.employmentType ? [this.formData.employmentType] : []
      }
    };

    const locationPayload = {
      location_preference: {
        country_id: this.formData.country || null,
        state_id: this.formData.state || null,
        dist_id: this.formData.district || null,
        city_id: this.formData.preferredCity || null,
        location_proximity: this.formData.locationProximity || null
      }
    };

    const lifestylePayload = {
      lifestyle_and_food_preference: {
        food: this.formData.dietPreference || null,
        smoking: this.formData.smoking || null,
        drinking: this.formData.drinking || null
      }
    };

    const horoscopePayload = {
      horoscope_preference: {
        rasi_id: this.formData.zodiac || null,
        natchr_id: this.formData.natchatra || null,
        dosham: this.formData.manglik || null,
        gothrm_id: this.formData.gothra || null
      }
    };

    const obs = [
      this.submitPreference('personal', personalPayload),
      this.submitPreference('religious', religiousPayload),
      this.submitPreference('education', educationPayload),
      this.submitPreference('profession', professionPayload),
      this.submitPreference('location', locationPayload),
      this.submitPreference('lifestyle_and_food', lifestylePayload),
      this.submitPreference('horoscope', horoscopePayload)
    ].filter(o => o !== null);

    forkJoin(obs).subscribe(
      (results) => {
        this.isSaving = false;
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Progress Saved',
          showConfirmButton: false,
          timer: 1500
        });
      },
      (error) => {
        this.isSaving = false;
        console.error('Error saving progress', error);
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Failed to save',
          showConfirmButton: false,
          timer: 1500
        });
      }
    );
  }

  saveAllPreferences() {
    Swal.fire({
      title: 'Updating Matchmaker Pipeline',
      text: 'Calculating premium connection scores based on your updated criteria...',
      icon: 'info',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();

        // Build payloads
        const personalPayload = {
          personal_preference: {
            age_from: this.formData.minAge,
            age_to: this.formData.maxAge,
            height_from: this.formData.minHeight,
            height_to: this.formData.maxHeight,
            weight_from: this.formData.minWeight,
            weight_to: this.formData.maxWeight,
            salary_from: this.formData.minSalary,
            salary_to: this.formData.maxSalary,
            marital_status: this.formData.maritalStatus || null,
            physical_status: this.formData.physicalStatus || null,
            family_type: this.formData.familyType || null,
            citizenship_id: this.formData.citizenship || null,
            language_id: this.formData.motherTongue || null
          }
        };

        const religiousPayload = {
          religious_preference: {
            religion_id: this.formData.religion || null,
            caste_id: this.formData.caste || null,
            sub_caste_id: this.formData.subcaste || null
          }
        };

        const educationPayload = {
          education_preference: {
            education_id: this.formData.education ? [this.formData.education] : [],
            higher_education_id: this.formData.higherEducation ? [this.formData.higherEducation] : []
          }
        };

        const professionPayload = {
          profession_preference: {
            occupation_id: this.formData.occupation ? [this.formData.occupation] : [],
            employmentype_id: this.formData.employmentType ? [this.formData.employmentType] : []
          }
        };

        const locationPayload = {
          location_preference: {
            country_id: this.formData.country || null,
            state_id: this.formData.state || null,
            dist_id: this.formData.district || null,
            city_id: this.formData.preferredCity || null,
            location_proximity: this.formData.locationProximity || null
          }
        };

        const lifestylePayload = {
          lifestyle_and_food_preference: {
            food: this.formData.dietPreference || null,
            smoking: this.formData.smoking || null,
            drinking: this.formData.drinking || null
          }
        };

        const horoscopePayload = {
          horoscope_preference: {
            rasi_id: this.formData.zodiac || null,
            natchr_id: this.formData.natchatra || null,
            dosham: this.formData.manglik || null,
            gothrm_id: this.formData.gothra || null
          }
        };

        // Fire all sequentially or in parallel using forkJoin
        const obs = [
          this.submitPreference('personal', personalPayload),
          this.submitPreference('religious', religiousPayload),
          this.submitPreference('education', educationPayload),
          this.submitPreference('profession', professionPayload),
          this.submitPreference('location', locationPayload),
          this.submitPreference('lifestyle_and_food', lifestylePayload),
          this.submitPreference('horoscope', horoscopePayload)
        ].filter(o => o !== null);

        forkJoin(obs).subscribe(
          (results) => {
            Swal.close();
            Swal.fire({
              title: 'Preferences Updated!',
              text: 'Our matchmaking algorithms have recalculated your scores.',
              icon: 'success',
              confirmButtonText: 'View Dashboard',
              confirmButtonColor: '#8c002a'
            }).then(() => {
              this.router.navigate(['/dashboard']);
            });
          },
          (error) => {
            Swal.close();
            console.error('Error saving all preferences', error);
            Swal.fire('Error', 'Failed to update preferences.', 'error');
          }
        );
      }
    });
  }
}
